// extracted by mini-css-extract-plugin
export var container = "style-module--container--e09ba";
export var crossed = "style-module--crossed--580c6";
export var form = "style-module--form--ef483";
export var formWrap = "style-module--form-wrap--0e181";
export var hours = "style-module--hours--3b34a";
export var info = "style-module--info--91d74";
export var minutes = "style-module--minutes--67f1d";
export var policy = "style-module--policy--2a740";
export var price = "style-module--price--0e922";
export var priceWrap = "style-module--price-wrap--ff951";
export var reg = "style-module--reg--30b27";
export var sub = "style-module--sub--94a58";
export var timer = "style-module--timer--ed812";
export var widget = "style-module--widget--3d583";